module.exports = __webpack_public_path__ + "static/media/magnum_logo.a1620e94.svg";